@let showJobTitleValue = showJobTitle();
@let jobValue = job();
@let interviewResultsCountValue = interviewResultsCount();
@let usersValue = users();
@let showPositionButtonValue = showPositionButton();

<div layout layout-space-between>
  <div layout-vertical>
    <rt-heading>
      <div>
        <span>{{ 'app.interview.summary.skills_summary.heading' | translate }}</span>
        @if (showJobTitleValue && jobValue) {
          <span>: {{ jobValue.title }}</span>
        }
      </div>
    </rt-heading>
    <div layout>
      <span margin-right-small-x>{{
        (interviewResultsCountValue === 1
          ? 'app.interview.summary.skills_summary.subheading_one'
          : 'app.interview.summary.skills_summary.subheading_other'
        ) | translate: { count: interviewResultsCountValue }
      }}</span>
      <rt-admins-avatars
        [admins]="usersValue"
        [avatarSize]="'small-x'"
        [stacked]="true"
        [limit]="3"
        [moreButtonAsCounter]="true"
        [counterAvatarTemplate]="counterAvatarTemplate"
      />
    </div>
  </div>
  @if (showPositionButtonValue) {
    <div layout margin-left-small-x>
      <rt-button variant="plain" size="small" (click)="onViewPosition()">
        {{ 'app.interview.summary.skills_summary.view_position' | translate }}
      </rt-button>
    </div>
  }
</div>
<rt-divider margin-top-small-x maring-bottom />

<ng-template #counterAvatarTemplate>
  <div class="avatar-counter">{{ usersValue.length }}</div>
</ng-template>
